module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318957.5ce197e4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318957.pdf
// module id = 841
// module chunks = 0